<template>
  <div class="minePage">
    <mythead :userInfo="userInfo" v-if="false"></mythead>

    <div class="btn_group">
      <div class="btn flex-rowc" @click="handleGo(1)">
        <i class="iconfont icon-xiaochengxu"></i>
        <span>小程序客户注册推荐</span>
        <i class="iconfont icon-yuyinjiantou"></i>
      </div>
      <div class="btn flex-rowc" v-if="false">
        <i class="iconfont icon-huiyuandaochudaoru"></i>
        <span>合作商家注册推荐</span>
        <i class="iconfont icon-yuyinjiantou"></i>
      </div>
    </div>

    <div class="userInfo_wrap column_wrap" v-if="false">
      <div class="title flex-between">
        <h1>个人信息</h1>
        <!-- <router-link to="/userIndex" class="edit flex-rowc" -->
        <router-link to="/userIndex/userEdit" class="flex-rowc edit"
          ><i class="iconfont icon-edit"></i> 编辑</router-link
        >
      </div>
      <div class="base_info_list">
        <div class="base_info_item flex-rowl">
          <div class="txt1 flex-rowc">
            <div class="icon_box flex-rowc">
              <i class="iconfont icon-xingmingyonghumingnicheng"></i>
            </div>
            姓名：
          </div>
          <div class="txt2">{{ userInfo.truename }}</div>
        </div>
        <div class="base_info_item flex-rowl">
          <div class="txt1 flex-rowc">
            <div class="icon_box flex-rowc">
              <i class="iconfont icon-shoujihaoma"></i>
            </div>
            工作手机：
          </div>
          <div class="txt2">{{ tuozhanInfo.mobile }}</div>
        </div>
        <div class="base_info_item flex-rowl">
          <div class="txt1 flex-rowc">
            <div class="icon_box flex-rowc">
              <i class="iconfont icon-weixin"></i>
            </div>
            工作微信：
          </div>
          <div class="txt2">{{ tuozhanInfo.weixin }}</div>
        </div>
        <div class="base_info_item flex-rowl">
          <div class="txt1 flex-rowc">
            <div class="icon_box flex-rowc">
              <i class="iconfont icon-gender"></i>
            </div>
            性别：
          </div>
          <div class="txt2">{{ userInfo.sex ? userInfo.sex : "" }}</div>
        </div>
        <div class="base_info_item flex-rowl">
          <div class="txt1 flex-rowc">
            <div class="icon_box flex-rowc">
              <i class="iconfont icon-nianling"></i>
            </div>
            年龄：
          </div>
          <div class="txt2">{{ userInfo.age ? userInfo.age : "" }}</div>
        </div>
        <div class="base_info_item">
          <div class="txt1 flex-rowl">
            <div class="icon_box flex-rowc">
              <i class="iconfont icon-weibiaoti-3"></i>
            </div>
            所在地区（日常活动范围）
          </div>
          <div class="txt">
            <van-field
              v-model="PCA_address"
              placeholder="省、市、自治区"
              readonly
            />
          </div>
          <div class="txt">
            <van-field
              v-model="userInfo.addr"
              placeholder="区、街道、详细地址"
              readonly
            />
          </div>
        </div>
      </div>
    </div>

    <div class="custom_btn return" @click="handleReturn">
      <i class="iconfont icon-yuyinjiantou"></i> 返回
    </div>
  </div>
</template>

<script>
import { getCompanyInfo } from "../../api/company";
import Clipboard from "clipboard";
import mythead from "../../components/head.vue";
import { Toast } from 'vant';
import { mapState } from "vuex";
export default {
  name: "userManageDetail",
  components: { mythead },
  data() {
    return {
      PCA_address: "",
      userInfo: "",
      tuozhanInfo: "",

      qyInfo: '',
    };
  },
  computed: {
    ...mapState(["OPENID"]),
  },
  created() {
    this.getInit();
    this.getCompanyInfo();
  },
  methods: {
    async getInit() {
      const toast = this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      // 获取用户
      let res1 = this.$store.state.USERINFO;
      this.userInfo = res1;
      if (res1.provincename) {
        this.PCA_address =
          (res1.provincename ? res1.provincename : "") +
          " " +
          (res1.cityname ? res1.cityname : "") +
          " " +
          (res1.areaname ? res1.areaname : "");
      }
      this.tuozhanInfo = res1.tuozhan.length > 0 ? res1.tuozhan[0] : "";
      toast.clear();
      this.isLoading = false;
    },

    // 获取企业
    getCompanyInfo() {
      getCompanyInfo({ openid: this.OPENID }).then((res) => {
        this.qyInfo = res.id ? res : ''
        console.log(this.qyInfo,'===this.qyInfo');
      });
    },

    // 复制
    handleCopyBtn() {
      let clipboard = new Clipboard(".copy_box");
      clipboard.on("success", () => {
        // console.log("复制成功",e);
        this.$toast.success("复制成功");
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        // 不支持复制
        console.log("该浏览器不支持自动复制", e);
        if (e.text) {
          this.$toast.fail("复制失败");
        } else {
          this.$toast("暂无内容");
        }
        // 释放内存
        clipboard.destroy();
      });
    },

    // 跳转页面
    handleGo(type) {
      let {qyInfo} = this
      if(!qyInfo.postappid) {
        Toast('未关联小程序的APPID')
        return
      }
      if(type == 1) {
        this.$router.push('/userIndex/userRegisterPoster')
      }
    },

    handleReturn() {
      this.$router.back();
    },
  },
};
</script>
<style lang="less" scoped>
.minePage {
  padding-bottom: 280px;
  box-sizing: border-box;
  .userInfo_wrap {
    padding: 29px 55px 0 81px;
    background: #fff;
    box-sizing: border-box;
    font-size: 24px;
    color: #333333;
    .title {
      margin-bottom: 60px;
      h1 {
        font-size: 30px;
        color: #333333;
      }
      .edit {
        padding: 0 20px;
        height: 35px;
        border-radius: 25px;
        background: #f62560;
        font-size: 18px;
        color: #fff;
        .icon-edit {
          margin-right: 5px;
          color: #fff;
          // font-size: 20px;
        }
      }
    }
    .base_info_item {
      margin-bottom: 60px;
    }
  }
  .btn_group {
    position: absolute;
    top: 20%;
    left: 50%;
    transform: translate(-50%, -50%);
    .btn {
      width: 600px;
      height: 110px;
      border: 1px solid #AAAAAA;
      margin: auto;
      font-size: 28px;
      color: #333333;
      position: relative;
      
      .icon-yuyinjiantou {
        font-size: 30px;
        position: absolute;
        transform: rotate(-90deg);
        right: 50px;
      }
      .icon-xiaochengxu {
        font-size: 36px;
        margin-right: 14px;
      }
      .icon-huiyuandaochudaoru {
        font-size: 46px;
        margin-right: 30px;
      }
    }
  }
  .custom_btn {
    position: fixed;
    left: 50%;
    transform: translateX(-50%);
    bottom: 300px;
  }
}
</style>